import pagination from "./elements/pagiantion";

const warehouseOrderList = {
  loading: false,
  pagination: pagination,
  list: [],
};

export default warehouseOrderList;
